import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "genericAddressSingleLine",
})
export class GenericAddressSingleLinePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) return "";

    let address1, address2, city, state, zip, zipExtension, county;

    if (value.address1) {
      address1 = value.address1;
    }

    if (value.address2) {
      address2 = value.address2;
    }

    if (value.city) {
      city = value.city;
    }

    if (value.state) {
      state = value.state;
    }

    if (value.zip) {
      zip = value.zip;
    }

    if (value.zipExtension) {
      zipExtension = value.zipExtension;
    }

    if (value.county) {
      county = value.county;
    }

    return `${address1 ? address1 : ""} ${city ? `, ${city}` : ""}${
      state ? `, ${state}  ` : ""
    } ${zip ? `${zip}` : ""} ${zipExtension ? `-${zipExtension}` : ""}${
      county ? `, ${county}` : ""
    }`;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/generic-address-single-line.pipe.ts